import React from 'react';

import Checkbox from '/component/base/Checkbox';
import ListItem from '/component/base/ListItem';
import Text from '/component/base/Text';
import {withTranslation} from '/provider/TranslationProvider';

import {FEATURE_FLAGS} from '/DevFeatureFlags';

interface CertificationContentProps {
  tt: (key: string, defaultValue?: string) => string;
  isComplete: boolean;
}

const CertificationContent: React.FC<CertificationContentProps> = ({
  tt,
  isComplete = false,
}) => {
  if (FEATURE_FLAGS.showCertificationReference) {
    return (
      <ListItem
        prefix={<Checkbox checked={isComplete} readonly />}
        label={<Text>{tt('label', 'Be Certified')}</Text>}
        readonly
      />
    );
  }
  return null;
};

export default withTranslation('report.closeToCompetencyContent.certification')(
  CertificationContent,
);
